/**
 * File: src/components/lightbox.js
 * Mô tả: Component Lightbox hiển thị ảnh screenshot ở kích thước toàn màn hình với bộ điều hướng.
 * Liên quan: src/state/modal-state.js, src/utils/accessibility.js, src/utils/media.js
 */

import { createElement } from '../utils/dom.js';
import { subscribeModalState, closeLightbox, nextScreenshot, prevScreenshot } from '../state/modal-state.js';
import { handleImageError } from '../utils/media.js';

export const renderLightbox = () => {
  const overlay = createElement('div', {
    className: 'modal-overlay',
    attributes: { id: 'lightbox-overlay', style: 'z-index: 600;' },
  });

  overlay.innerHTML = `
    <button class="modal-close-btn" id="lightbox-close" aria-label="Đóng Lightbox" style="top: 24px; right: 24px;">✕</button>
    <button id="lightbox-prev" aria-label="Ảnh trước đó" style="position: absolute; left: 24px; top: 50%; transform: translateY(-50%); font-size: 2.5rem; color: #fff; z-index: 10;">❮</button>
    <button id="lightbox-next" aria-label="Ảnh tiếp theo" style="position: absolute; right: 24px; top: 50%; transform: translateY(-50%); font-size: 2.5rem; color: #fff; z-index: 10;">❯</button>
    
    <div style="max-width: 90vw; max-height: 85vh; display: flex; flex-direction: column; align-items: center;">
      <img id="lightbox-img" src="" alt="Full Screenshot" style="max-width: 100%; max-height: 80vh; object-fit: contain; border-radius: 8px; box-shadow: 0 10px 40px rgba(0,0,0,0.9);" />
      <span id="lightbox-counter" style="margin-top: 12px; color: var(--color-text-muted); font-size: 0.95rem;"></span>
    </div>
  `;

  const imgEl = overlay.querySelector('#lightbox-img');
  const counterEl = overlay.querySelector('#lightbox-counter');
  handleImageError(imgEl);

  // Gắn sự kiện nút bấm
  overlay.querySelector('#lightbox-close').addEventListener('click', closeLightbox);
  overlay.querySelector('#lightbox-prev').addEventListener('click', prevScreenshot);
  overlay.querySelector('#lightbox-next').addEventListener('click', nextScreenshot);

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeLightbox();
  });

  // Điều hướng bàn phím (Phím mũi tên & Esc)
  window.addEventListener('keydown', (e) => {
    if (overlay.classList.contains('open')) {
      if (e.key === 'ArrowRight') nextScreenshot();
      if (e.key === 'ArrowLeft') prevScreenshot();
      if (e.key === 'Escape') closeLightbox();
    }
  });

  // Lắng nghe state
  subscribeModalState(({ activeScreenshots, activeScreenshotIndex, isLightboxOpen }) => {
    if (isLightboxOpen && activeScreenshots.length > 0) {
      overlay.classList.add('open');
      imgEl.src = activeScreenshots[activeScreenshotIndex];
      counterEl.textContent = `Hình ảnh ${activeScreenshotIndex + 1} / ${activeScreenshots.length}`;
    } else {
      overlay.classList.remove('open');
    }
  });

  return overlay;
};
